import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const View = styled.h1`
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    font-weight: 800;
    font-size: ${props => (props.size === 'small' ? '24px' : '48px')};
    color: ${props => props.color};
    line-height: 0.9;
    font-family: 'Open Sans';
`;

const whitespaceToBr = str => {
    return (
        <div>{str.split(' ').map(text => <div key={text}>{text}</div>)}</div>
    );
};

const ProductTitle = props => {
    return (
        <View color={props.color} size={props.size} className={props.className}>
            {props.size === 'normal'
                ? whitespaceToBr(props.children)
                : props.children}
        </View>
    );
};

ProductTitle.defaultProps = {
    color: 'inherit',
    size: 'normal',
};

ProductTitle.propTypes = {
    /** alle validen CSS Farben */
    color: PropTypes.string,

    /** ['normal', 'small'] */
    size: PropTypes.oneOf(['normal', 'small']),
};

export default ProductTitle;



// WEBPACK FOOTER //
// ./src/components/shared/ProductTitle.js